import React from 'react';
import { Badge, Card, Progress } from 'antd';
import './StatCard.css';

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  subtitle: string;
  iconBgColor: 'green' | 'blue';
  badge?: {
    value: string;
    type: 'positive' | 'negative';
  };
  progress?: {
    percent: number;
    color: string;
  };
  footer?: string;
  comingSoon?: boolean;
  style?: React.CSSProperties;
  loading?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  subtitle,
  iconBgColor,
  badge,
  progress,
  footer,
  comingSoon,
  style,
  loading,
}) => {
  return (
    <Card className={`stat-card ${comingSoon ? 'stat-card--coming-soon' : ''}`} style={style} loading={loading}>
      <div className="stat-card__header">
        <div className={`stat-card__icon stat-card__icon--${iconBgColor}`}>{icon}</div>
        <span className="stat-card__label">{label}</span>
        {comingSoon && <Badge count="Soon" className="soon-badge" />}
      </div>
      <div className="stat-card__body">
        <div className="stat-card__value-row">
          <span className="stat-card__value">{value}</span>
          {badge && (
            <span className={`stat-card__badge stat-card__badge--${badge.type}`}>
              {badge.value}
            </span>
          )}
        </div>
        <span className="stat-card__subtitle">{subtitle}</span>
        {progress && (
          <Progress
            percent={progress.percent}
            showInfo={false}
            strokeColor={progress.color}
            trailColor="#e5e7eb"
            className="stat-card__progress"
          />
        )}
        {footer && <span className="stat-card__footer">{footer}</span>}
      </div>
    </Card>
  );
};

export default StatCard;
